var COEFFICIENTS, COHEN_EFFECT_SIZE_THRESHOLDS, OUTCOME_SCALE_TYPES, QS, THRESHOLDS, allOutcomesUseMinimallyImportantDifferences, calculateThreshold, calculateThresholds, etdTemplateHelper, formatOutcomeDecimal, formatOutcomeThresholdValue, getOutcomeField, getOutcomeThresholdDenominator, getOutcomeThresholdItems, getOutcomeThresholdTableHeader, getOutcomeThresholdTableRow, getOutcomeThresholdsString, getOutcomesList, getOutcomesThresholdTable, hasOutcomeThresholds;

QS = require('models/outcome/quality_scores');

etdTemplateHelper = require('stores/utils/etd_template_helper');

OUTCOME_SCALE_TYPES = ['ordinal', 'ratioOrInterval'];

THRESHOLDS = [0.073, 0.18, 0.338];

COHEN_EFFECT_SIZE_THRESHOLDS = [0.2, 0.5, 0.8];

COEFFICIENTS = [0.061, 0.146, 0.271];

calculateThreshold = function(utility, thresholdIndex, denominator, higherIsBetter, outcomeType, effectMeasure) {
  var disutility;
  if (outcomeType === 'cont' && effectMeasure === 'SMD') {
    return COHEN_EFFECT_SIZE_THRESHOLDS[thresholdIndex];
  } else if (outcomeType === 'cont') {
    return;
  }
  disutility = higherIsBetter ? utility : 1 - parseFloat(utility);
  return Number(((THRESHOLDS[thresholdIndex] - (COEFFICIENTS[thresholdIndex] * disutility)) * denominator).toFixed(0));
};

calculateThresholds = function(_arg) {
  var denominator, effectMeasure, higherIsBetter, outcomeType, thresholdDenominator, type, utility, utilityValue;
  utilityValue = _arg.utilityValue, denominator = _arg.denominator, higherIsBetter = _arg.higherIsBetter, type = _arg.type, effectMeasure = _arg.effectMeasure;
  utility = Number(utilityValue) || 0;
  thresholdDenominator = Number(denominator) || 1000;
  outcomeType = type;
  return {
    thresholdT1: calculateThreshold(utility, 0, thresholdDenominator, higherIsBetter, outcomeType, effectMeasure),
    thresholdT2: calculateThreshold(utility, 1, thresholdDenominator, higherIsBetter, outcomeType, effectMeasure),
    thresholdT3: calculateThreshold(utility, 2, thresholdDenominator, higherIsBetter, outcomeType, effectMeasure)
  };
};

getOutcomeField = function(outcome, fieldName, fallback) {
  var value;
  if (fallback == null) {
    fallback = '';
  }
  value = outcome.get != null ? outcome.get(fieldName) : outcome[fieldName];
  return value != null ? value : fallback;
};

getOutcomesList = function(outcomes) {
  if (outcomes.toArray != null) {
    return outcomes.toArray();
  } else {
    return outcomes;
  }
};

getOutcomeThresholdItems = function(outcome) {
  switch (getOutcomeField(outcome, 'thresholdsType')) {
    case 'MinimallyImportantDifferences':
      return [
        {
          labelKey: 'T',
          valueKey: 'thresholdT1'
        }
      ];
    case 'MagnitudeOfEffect':
      return [
        {
          labelKey: 'T1',
          valueKey: 'thresholdT1'
        }, {
          labelKey: 'T2',
          valueKey: 'thresholdT2'
        }, {
          labelKey: 'T3',
          valueKey: 'thresholdT3'
        }
      ];
    default:
      return [];
  }
};

getOutcomeThresholdDenominator = function(outcome) {
  return Number(getOutcomeField(outcome, 'denominator', getOutcomeField(outcome, 'absDenominator'))) || 1000;
};

formatOutcomeDecimal = function(value, digits) {
  var numberValue;
  if (digits == null) {
    digits = 2;
  }
  if (value == null) {
    return '';
  }
  numberValue = Number(value);
  if (isNaN(numberValue)) {
    return '';
  }
  return numberValue.toFixed(digits).replace(/\.?0+$/, '');
};

formatOutcomeThresholdValue = function(outcome, value) {
  if (value == null) {
    return '';
  }
  if (value === '') {
    return '';
  }
  if (getOutcomeField(outcome, 'type') === 'cont') {
    return $.t('es:outcome.cont_outcome_threshold', {
      value: value != null ? value : '',
      units: getOutcomeField(outcome, 'units')
    });
  } else {
    return $.t('es:outcome.dich_outcome_threshold', {
      value: value != null ? value : '',
      denominator: getOutcomeThresholdDenominator(outcome)
    });
  }
};

getOutcomeThresholdsString = function(outcome) {
  var thresholdItems;
  thresholdItems = getOutcomeThresholdItems(outcome);
  if (_(thresholdItems).isEmpty()) {
    return '';
  }
  return thresholdItems.map(function(thresholdItem) {
    var label, value;
    label = $.t("nma:thresholds.thresholds." + thresholdItem.labelKey);
    value = getOutcomeField(outcome, thresholdItem.valueKey);
    return "" + label + ": " + (formatOutcomeThresholdValue(outcome, value));
  }).join(' | ');
};

hasOutcomeThresholds = function(outcome) {
  return !_(getOutcomeThresholdItems(outcome)).isEmpty();
};

allOutcomesUseMinimallyImportantDifferences = function(outcomes) {
  return outcomes.length > 0 && _.every(outcomes, function(outcome) {
    return getOutcomeField(outcome, 'thresholdsType') === 'MinimallyImportantDifferences';
  });
};

getOutcomeThresholdTableHeader = function(outcomes) {
  var i18nKeyPrefix, thresholdColSpan, thresholdColumns, thresholdHeaderLabel, useMinimallyImportantDifferences;
  useMinimallyImportantDifferences = allOutcomesUseMinimallyImportantDifferences(outcomes);
  thresholdColSpan = useMinimallyImportantDifferences ? 1 : 3;
  i18nKeyPrefix = etdTemplateHelper.isAcpFeaturesOn() ? 'acp_' : '';
  thresholdHeaderLabel = useMinimallyImportantDifferences ? $.t('es:outcome.minimally_important_differences') : $.t('es:outcome.magnitude_of_effect_thresholds');
  thresholdColumns = useMinimallyImportantDifferences ? "<th>" + ($.t('es:outcome.threshold')) + "</th>" : "<th>" + ($.t("es:outcome." + i18nKeyPrefix + "trivial_small_effect")) + "</th> <th>" + ($.t("es:outcome." + i18nKeyPrefix + "small_moderate_effect")) + "</th> <th>" + ($.t("es:outcome." + i18nKeyPrefix + "moderate_large_effect")) + "</th>";
  return "<tr> <th rowspan=\"2\">" + ($.t('es:outcome.prioritized_outcomes')) + "</th> <th colspan=\"1\">" + ($.t('es:outcome.outcome_importance')) + "</th> <th colspan=\"" + thresholdColSpan + "\">" + thresholdHeaderLabel + "</th> </tr> <tr> <th>" + ($.t('es:outcome.health_utility_values')) + "</th> " + thresholdColumns + " </tr>";
};

getOutcomeThresholdTableRow = function(outcome, useMinimallyImportantDifferences) {
  var outcomeName, thresholdCells, thresholdT1, thresholdT2, thresholdT3, utility, utilityValue;
  outcomeName = _.string.escapeHTML(getOutcomeField(outcome, 'name'));
  utilityValue = getOutcomeField(outcome, 'utilityValue', 0);
  utility = Number(utilityValue) || 0;
  thresholdT1 = _.string.escapeHTML(formatOutcomeThresholdValue(outcome, getOutcomeField(outcome, 'thresholdT1')));
  thresholdT2 = _.string.escapeHTML(formatOutcomeThresholdValue(outcome, getOutcomeField(outcome, 'thresholdT2')));
  thresholdT3 = _.string.escapeHTML(formatOutcomeThresholdValue(outcome, getOutcomeField(outcome, 'thresholdT3')));
  thresholdCells = useMinimallyImportantDifferences ? "<td>" + thresholdT1 + "</td>" : "<td>" + thresholdT1 + "</td> <td>" + thresholdT2 + "</td> <td>" + thresholdT3 + "</td>";
  return "<tr> <td>" + outcomeName + "</td> <td>" + (formatOutcomeDecimal(utility, 3)) + "</td> " + thresholdCells + " </tr>";
};

getOutcomesThresholdTable = function(outcomes) {
  var rows, useMinimallyImportantDifferences;
  useMinimallyImportantDifferences = allOutcomesUseMinimallyImportantDifferences(outcomes);
  rows = outcomes.map(function(outcome) {
    return getOutcomeThresholdTableRow(outcome, useMinimallyImportantDifferences);
  });
  return "<table class=\"etd-outcomes-thresholds-table\" border=\"1\" cellspacing=\"0\" cellpadding=\"0\"> <thead> " + (getOutcomeThresholdTableHeader(outcomes)) + " </thead> <tbody> " + (rows.join('')) + " </tbody> </table>";
};

module.exports = {
  OUTCOME_SCALE_TYPES: OUTCOME_SCALE_TYPES,
  THRESHOLDS: THRESHOLDS,
  COEFFICIENTS: COEFFICIENTS,
  COHEN_EFFECT_SIZE_THRESHOLDS: COHEN_EFFECT_SIZE_THRESHOLDS,
  calculateThreshold: calculateThreshold,
  calculateThresholds: calculateThresholds,
  getOutcomeField: getOutcomeField,
  getOutcomesList: getOutcomesList,
  getOutcomeThresholdItems: getOutcomeThresholdItems,
  getOutcomeThresholdDenominator: getOutcomeThresholdDenominator,
  formatOutcomeDecimal: formatOutcomeDecimal,
  formatOutcomeThresholdValue: formatOutcomeThresholdValue,
  getOutcomeThresholdsString: getOutcomeThresholdsString,
  hasOutcomeThresholds: hasOutcomeThresholds,
  allOutcomesUseMinimallyImportantDifferences: allOutcomesUseMinimallyImportantDifferences,
  getOutcomesThresholdTable: getOutcomesThresholdTable,
  isCaseControlType: function(designStudies) {
    return designStudies === 'case_control_studies' || designStudies === 'case_control_and_other_combined' || designStudies === 'test_negative_design';
  },
  prepareDiagnosticOutcomes: function() {
    return ['TP', 'FN', 'TN', 'FP', 'Inconclusive', 'Complications'].map(function(name, idx) {
      return {
        name: name,
        largeEffect: QS.No,
        plausibleConfounding: QS.No,
        doseResponseGradient: QS.No,
        orderNumber: idx + 1
      };
    });
  }
};
